/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Ai_Api_Keys_DetailInputs */

const en_common_header_ai_api_keys_detail = /** @type {(inputs: Common_Header_Ai_Api_Keys_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage API access`)
};

const zh_common_header_ai_api_keys_detail = /** @type {(inputs: Common_Header_Ai_Api_Keys_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理 API 访问`)
};

/**
* | output |
* | --- |
* | "Manage API access" |
*
* @param {Common_Header_Ai_Api_Keys_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_ai_api_keys_detail = /** @type {((inputs?: Common_Header_Ai_Api_Keys_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Ai_Api_Keys_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_ai_api_keys_detail(inputs)
	return zh_common_header_ai_api_keys_detail(inputs)
});
export { common_header_ai_api_keys_detail as "common.header.ai.api_keys.detail" }